import { Component } from 'react';
import styled from 'styled-components';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText, PLATFORM_STATUS_URL } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Button, Stack } from '@optimus-web/core';
import { DangerouslySetHtmlContent } from '../backendRendering';
import { ContentContainer } from '../layout';
import { NewTabLink } from '../navigation';

interface ErrorHandlerProps {
    errorMessage?: React.ReactNode;
    errorTitle?: React.ReactNode;
    onTryAgain?: () => void;
    onDismiss?: () => void;
    stackTrace?: string | null;
}

export class ErrorHandler extends Component<ErrorHandlerProps> {
    static defaultProps = {
        errorMessage: <LocalizedText textKey={TextKey.FatalErrorMessage} />,
    };

    render() {
        const { errorMessage, onTryAgain, onDismiss, errorTitle, stackTrace } = this.props;

        return (
            <ContentContainer style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                <Stack vertical alignment="center" spacing="200">
                    <Stack alignment="center">
                        <Banner
                            primaryText={errorTitle || <LocalizedText textKey={TextKey.UnexpectedError} />}
                            secondaryText={
                                <>
                                    {errorMessage || <LocalizedText textKey={TextKey.UnexpectedErrorMessage} />}
                                    {UnicodeEntity.NoBreakSpace}
                                    <NewTabLink url={PLATFORM_STATUS_URL}>{PLATFORM_STATUS_URL}</NewTabLink>
                                </>
                            }
                            variant="error"
                        />
                    </Stack>
                    <Stack alignment="center" spacing="100">
                        {onDismiss && (
                            <Button onClick={onDismiss} type="submit">
                                <LocalizedText textKey={TextKey.Dismiss} />
                            </Button>
                        )}
                        {onTryAgain && (
                            <Button onClick={onTryAgain} type="submit">
                                <LocalizedText textKey={TextKey.TryAgain} />
                            </Button>
                        )}
                    </Stack>
                    {stackTrace && (
                        <StackTrace>
                            <DangerouslySetHtmlContent html={stackTrace} />
                        </StackTrace>
                    )}
                </Stack>
            </ContentContainer>
        );
    }
}

const StackTrace = styled.pre`
    white-space: pre-wrap;
`;
